import type { HourlyCell } from "@/lib/types";
import { cn } from "@/lib/utils";

const DOW = ["일", "월", "화", "수", "목", "금", "토"];

/** 7×24 셀의 CSS Grid 히트맵. 색상은 max 대비 비율 기반. */
export function HourlyHeatmap({ data }: { data: HourlyCell[] }) {
  const grid: number[][] = Array.from({ length: 7 }, () => Array(24).fill(0));
  let max = 0;
  for (const c of data) {
    if (c.dow >= 0 && c.dow < 7 && c.hour >= 0 && c.hour < 24) {
      grid[c.dow][c.hour] = c.count;
      if (c.count > max) max = c.count;
    }
  }

  if (max === 0) {
    return (
      <div className="flex h-32 items-center justify-center text-sm text-muted-foreground">
        데이터 없음
      </div>
    );
  }

  return (
    <div className="overflow-x-auto">
      <table className="w-full table-fixed border-separate border-spacing-0.5 text-xs">
        <thead>
          <tr>
            <th className="w-8" />
            {Array.from({ length: 24 }).map((_, h) => (
              <th key={h} className="pb-1 text-center text-[10px] text-muted-foreground">
                {h}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {DOW.map((d, i) => (
            <tr key={d}>
              <td className="pr-1 text-right text-[10px] text-muted-foreground">{d}</td>
              {grid[i].map((v, h) => (
                <td
                  key={h}
                  title={`${d} ${h}:00 — ${v}건`}
                  className={cn(
                    "aspect-square rounded-sm",
                    cellColor(v / max),
                  )}
                />
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

function cellColor(ratio: number): string {
  if (ratio === 0) return "bg-muted";
  if (ratio < 0.15) return "bg-yellow-100";
  if (ratio < 0.3) return "bg-yellow-300";
  if (ratio < 0.5) return "bg-orange-300";
  if (ratio < 0.7) return "bg-orange-500";
  if (ratio < 0.9) return "bg-red-500";
  return "bg-red-700";
}
